/**
 * Consegna all'utente un file generato dall'app: Share Sheet o download.
 *
 * Lo Share Sheet (Web Share API) serve dove salvare un file è scomodo, cioè
 * iPhone e iPad. Sul desktop `navigator.canShare` risponde comunque di sì, ma
 * il pannello di condivisione del sistema elenca delle app e NON salva il
 * documento: l'utente resta col bottone che gira e senza file (visto davvero,
 * su Mac, sul PDF del DDT). Lì si scarica e basta.
 *
 * Si condividono SEMPRE e SOLO i file, mai `title`/`text`/`url`: su iOS
 * aggiungerli fa sparire l'allegato in alcune app, e con un URL iOS ne
 * scarica l'anteprima rallentando tutto.
 */

/** true dove ha senso aprire il foglio di condivisione invece di scaricare. */
export const preferisciCondivisione = () => Boolean(
  typeof navigator !== 'undefined'
  && typeof navigator.canShare === 'function'
  && navigator.maxTouchPoints > 1
  && typeof window !== 'undefined'
  && window.matchMedia
  && window.matchMedia('(pointer: coarse)').matches,
);

/** Scarica un Blob/File (o un object-URL già pronto) col nome indicato. */
export function scaricaFile(origine, nome) {
  const creato = typeof origine !== 'string';
  const href = creato ? URL.createObjectURL(origine) : origine;
  const a = document.createElement('a');
  a.href = href;
  a.download = nome;
  document.body.appendChild(a);   // Firefox non segue un <a> non attaccato
  a.click();
  a.remove();
  if (creato) setTimeout(() => URL.revokeObjectURL(href), 30000);
}

/**
 * Condivide il file dove ha senso, altrimenti lo scarica.
 * `url` opzionale: object-URL già creato dal chiamante, per non duplicarlo.
 * Ritorna 'condiviso' | 'scaricato' | 'annullato' — serve a chi deve fare
 * qualcosa DOPO il download (es. aprire WhatsApp col testo).
 */
export async function condividiOScarica(file, { url, nome } = {}) {
  const nomeFile = nome || file.name;
  if (preferisciCondivisione() && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
      return 'condiviso';
    } catch (e) {
      if (e?.name === 'AbortError') return 'annullato';
      // qualunque altro errore: si ripiega sul download
    }
  }
  scaricaFile(url || file, nomeFile);
  return 'scaricato';
}
